import { useState, useEffect, useRef } from 'react'
import '../../landing.css'

// ── Inline SVG icons ──────────────────────────────────────────────────────
function IconArrowRight() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 12h14M12 5l7 7-7 7"/>
    </svg>
  )
}
function IconCheck() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="20 6 9 17 4 12"/>
    </svg>
  )
}
function IconX() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
    </svg>
  )
}
function IconCheckCircle() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
      <polyline points="22 4 12 14.01 9 11.01"/>
    </svg>
  )
}
function IconTrendingDown() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="23 18 13.5 8.5 8.5 13.5 1 6"/>
      <polyline points="17 18 23 18 23 12"/>
    </svg>
  )
}
function IconLayoutDashboard() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/>
      <rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/>
    </svg>
  )
}
function IconCreditCard() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="1" y="4" width="22" height="16" rx="2" ry="2"/>
      <line x1="1" y1="10" x2="23" y2="10"/>
    </svg>
  )
}
function IconTarget() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/>
    </svg>
  )
}
function IconBarChart() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/>
      <line x1="6" y1="20" x2="6" y2="14"/><line x1="2" y1="20" x2="22" y2="20"/>
    </svg>
  )
}
function IconRepeat() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="17 1 21 5 17 9"/><path d="M3 11V9a4 4 0 0 1 4-4h14"/>
      <polyline points="7 23 3 19 7 15"/><path d="M21 13v2a4 4 0 0 1-4 4H3"/>
    </svg>
  )
}
function IconUsers() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
      <circle cx="9" cy="7" r="4"/>
      <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
      <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
    </svg>
  )
}
function IconMessageCircle() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
    </svg>
  )
}
function IconSparkles() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 3L9.5 9.5 3 12l6.5 2.5L12 21l2.5-6.5L21 12l-6.5-2.5z"/>
    </svg>
  )
}
function IconStar() {
  return (
    <svg viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
    </svg>
  )
}

// ── Reveal hook ───────────────────────────────────────────────────────────
function useReveal() {
  useEffect(() => {
    const io = new IntersectionObserver((entries) => {
      for (const e of entries) {
        if (e.isIntersecting) {
          e.target.classList.add('is-visible')
          io.unobserve(e.target)
        }
      }
    }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' })
    document.querySelectorAll('.lp-reveal').forEach(el => io.observe(el))
    return () => io.disconnect()
  }, [])
}

interface Props {
  onSignIn: () => void
}

export default function LandingPage({ onSignIn }: Props) {
  const [scrolled, setScrolled] = useState(false)
  const [period, setPeriod] = useState<'month' | 'year'>('month')
  const [openFaq, setOpenFaq] = useState<number | null>(null)
  const headerRef = useRef<HTMLElement>(null)

  useReveal()

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 8)
    window.addEventListener('scroll', handler, { passive: true })
    return () => window.removeEventListener('scroll', handler)
  }, [])

  // Trigger reveal for elements already in viewport on mount
  useEffect(() => {
    document.querySelectorAll('.lp-reveal').forEach(el => {
      const rect = el.getBoundingClientRect()
      if (rect.top < window.innerHeight) el.classList.add('is-visible')
    })
  }, [])

  const prices = {
    individual: { month: 'R$ 19,90', year: 'R$ 14,99' },
    casal:      { month: 'R$ 29,90', year: 'R$ 22,49' },
  }
  const priceSub = {
    individual: {
      month: 'Cobrança mensal',
      year: 'R$ 179,90/ano · equivale a R$ 14,99/mês',
    },
    casal: {
      month: 'Para os dois, juntos',
      year: 'R$ 269,90/ano · equivale a R$ 22,49/mês',
    },
  }

  const faqs = [
    { q: 'Preciso de CNPJ ou conta empresa?', a: 'Não. O BagCash é para finanças pessoais. Funciona só com CPF e seu email.' },
    { q: 'O plano gratuito tem prazo?', a: 'Não. É grátis para sempre. Você só assina o Pro se quiser desbloquear cartões ilimitados, histórico completo, IA e modo casal.' },
    { q: 'Como funciona o plano anual?', a: 'Você paga uma vez por ano e fica 25% mais barato que o mensal. O Pro Individual anual custa R$ 179,90 (equivale a R$ 14,99/mês). O Pro Casal anual custa R$ 269,90 (equivale a R$ 22,49/mês).' },
    { q: 'O bot do WhatsApp é seguro?', a: 'Sim. Não armazenamos o conteúdo das suas conversas. Usamos o número apenas para reconhecer você e registrar a transação que você descreveu.' },
    { q: 'Posso cancelar a qualquer momento?', a: 'Sim, sem multa e sem perguntas. Você cancela em dois cliques nas configurações e mantém o acesso até o fim do ciclo já pago.' },
    { q: 'O casal precisa de dois cadastros?', a: 'Sim. Cada pessoa tem o próprio login (privacidade importa). O Pro Casal vincula as duas contas e libera o dashboard conjunto, com a opção de marcar despesas como privadas se quiser.' },
    { q: 'Meus dados ficam seguros?', a: 'Sim. Criptografia em trânsito e em repouso, e nunca vendemos seus dados — o produto é pago, não somos um anúncio disfarçado.' },
  ]

  function scrollTo(id: string) {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <div style={{ background: 'var(--sand-1)' }}>

      {/* ═══ HEADER ═══ */}
      <header ref={headerRef} className={`lp-header${scrolled ? ' is-scrolled' : ''}`}>
        <div className="lp-container lp-header__inner">
          <button className="lp-brand" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <img src="/logo-mark.svg" alt="BagCash" />
            BagCash
          </button>
          <nav className="lp-nav">
            <a href="#features" onClick={e => { e.preventDefault(); scrollTo('features') }}>Recursos</a>
            <a href="#how" onClick={e => { e.preventDefault(); scrollTo('how') }}>Como funciona</a>
            <a href="#planos" onClick={e => { e.preventDefault(); scrollTo('planos') }}>Planos</a>
            <a href="#faq" onClick={e => { e.preventDefault(); scrollTo('faq') }}>Perguntas</a>
          </nav>
          <div className="lp-header__cta">
            <button className="lp-btn lp-btn--ghost" onClick={onSignIn}>Entrar</button>
            <button className="lp-btn lp-btn--primary" onClick={onSignIn}>
              <span>Começar grátis</span>
            </button>
          </div>
        </div>
      </header>

      {/* ═══ HERO ═══ */}
      <section className="lp-hero lp-section">
        <div className="lp-container">
          <div className="lp-hero__grid">
            <div className="lp-hero__copy lp-reveal">
              <div className="lp-hero__badge">
                <IconSparkles />
                <span>Seu assistente financeiro com IA</span>
              </div>
              <h1 className="lp-h1">Pare de perder dinheiro <em>sem saber onde ele vai.</em></h1>
              <p className="lp-lead" style={{ marginTop: 18 }}>
                O BagCash é seu assistente financeiro com IA — organiza entradas, saídas, cartões
                e fecha o mês pra você, via dashboard ou direto no WhatsApp.
                Para você ou para o casal.
              </p>
              <div className="lp-hero__ctas">
                <button className="lp-btn lp-btn--primary lp-btn--lg" onClick={onSignIn}>
                  Começar grátis
                  <IconArrowRight />
                </button>
                <button className="lp-btn lp-btn--ghost lp-btn--lg" onClick={() => scrollTo('planos')}>
                  Ver planos
                </button>
              </div>
              <div className="lp-hero__trust">
                <IconCheckCircle />
                <span>Sem cartão de crédito para começar.</span>
              </div>
            </div>

            <div className="lp-hero__mock-wrap lp-reveal">
              <div className="lp-mock" aria-hidden="true">
                <div className="lp-mock__bar">
                  <span>bagcash.app</span>
                </div>
                <div className="lp-mock__month">
                  <span className="lp-mock__month-name">maio</span>
                  <span className="lp-mock__month-year">2026</span>
                </div>
                <div className="lp-mock__kpis">
                  <div className="lp-mock__kpi">
                    <div className="lp-mock__kpi-lbl">Receitas</div>
                    <div className="lp-mock__kpi-val pos">R$&nbsp;4.500</div>
                  </div>
                  <div className="lp-mock__kpi">
                    <div className="lp-mock__kpi-lbl">Despesas</div>
                    <div className="lp-mock__kpi-val neg">R$&nbsp;3.330</div>
                  </div>
                  <div className="lp-mock__kpi">
                    <div className="lp-mock__kpi-lbl">Saldo</div>
                    <div className="lp-mock__kpi-val pos">+R$&nbsp;1.170</div>
                  </div>
                </div>
                <div className="lp-mock__list">
                  <div className="lp-mock__tx">
                    <div className="lp-mock__tx-ico in">SA</div>
                    <div>
                      <div className="lp-mock__tx-title">Salário</div>
                      <div className="lp-mock__tx-meta">Entrada · recorrente</div>
                    </div>
                    <div className="lp-mock__tx-amt in">+ 4.500,00</div>
                  </div>
                  <div className="lp-mock__tx">
                    <div className="lp-mock__tx-ico out">AL</div>
                    <div>
                      <div className="lp-mock__tx-title">Aluguel</div>
                      <div className="lp-mock__tx-meta">Saída · mensal</div>
                    </div>
                    <div className="lp-mock__tx-amt out">− 1.200,00</div>
                  </div>
                  <div className="lp-mock__tx">
                    <div className="lp-mock__tx-ico out">ME</div>
                    <div>
                      <div className="lp-mock__tx-title">Mercado</div>
                      <div className="lp-mock__tx-meta">Pão de Açúcar</div>
                    </div>
                    <div className="lp-mock__tx-amt out">− 680,00</div>
                  </div>
                  <div className="lp-mock__tx">
                    <div className="lp-mock__tx-ico out">CC</div>
                    <div>
                      <div className="lp-mock__tx-title">Fatura Nubank</div>
                      <div className="lp-mock__tx-meta">Cartão · maio</div>
                    </div>
                    <div className="lp-mock__tx-amt out">− 1.450,00</div>
                  </div>
                </div>
                <div className="lp-mock__float">
                  <div className="lp-mock__float-ico"><IconTrendingDown /></div>
                  <div className="lp-mock__float-text">
                    <span className="lp-mock__float-t">Você gastou 28% menos</span>
                    <span className="lp-mock__float-s">em mercado vs abril</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ═══ PROBLEMA ═══ */}
      <section className="lp-problem lp-section">
        <div className="lp-container">
          <div className="lp-section__head lp-reveal">
            <p className="lp-eyebrow" style={{ color: 'var(--expense-700)' }}>O problema</p>
            <h2 className="lp-h2">Você se reconhece em alguma dessas?</h2>
          </div>
          <div className="lp-problem__grid">
            <article className="lp-pain lp-reveal">
              <p className="lp-pain__quote">Você fecha o mês sem saber onde o dinheiro foi.</p>
            </article>
            <article className="lp-pain lp-reveal">
              <p className="lp-pain__quote">Cada cartão num lugar diferente, sem visão unificada.</p>
            </article>
            <article className="lp-pain lp-reveal">
              <p className="lp-pain__quote">Vocês dois gastam, mas nunca têm um painel em comum.</p>
            </article>
          </div>
          <p className="lp-problem__transition lp-reveal">
            <strong>O BagCash resolve isso.</strong>{' '}
            Tudo num só painel — entradas, saídas, cartões e o que falta pro fim do mês.
          </p>
        </div>
      </section>

      {/* ═══ FEATURES ═══ */}
      <section className="lp-section" id="features" style={{ background: 'var(--sand-1)' }}>
        <div className="lp-container">
          <div className="lp-section__head lp-reveal">
            <p className="lp-eyebrow">Recursos</p>
            <h2 className="lp-h2">Tudo o que você precisa pra entender seu dinheiro.</h2>
            <p className="lp-lead">Da entrada do salário ao último café no aplicativo — o BagCash organiza, agrupa e mostra.</p>
          </div>
          <div className="lp-features__grid">
            {[
              { ico: <IconLayoutDashboard />, cls: '', title: 'Dashboard mensal', desc: 'Entradas, saídas e saldo num só lugar, mês a mês.', tag: null },
              { ico: <IconCreditCard />, cls: 'is-out', title: 'Cartões de crédito', desc: 'Cadastre todos os cartões e veja a fatura separada por cartão.', tag: null },
              { ico: <IconTarget />, cls: 'is-warn', title: 'Categorias com limite', desc: 'Defina quanto pode gastar em cada categoria e receba alertas.', tag: null },
              { ico: <IconBarChart />, cls: 'is-info', title: 'Visão anual', desc: '12 meses de receitas vs despesas num gráfico claro.', tag: null },
              { ico: <IconRepeat />, cls: '', title: 'Transações recorrentes', desc: 'Marque seus gastos fixos uma vez — eles aparecem todo mês.', tag: null },
              { ico: <IconUsers />, cls: 'is-in', title: 'Casal em tempo real', desc: 'Dashboard conjunto — o que um gasta, o outro vê na hora.', tag: { label: 'Pro Casal', style: { background: 'var(--income-50)', color: 'var(--income-700)', borderColor: 'var(--income-100)' } } },
              { ico: <IconMessageCircle />, cls: '', title: 'Bot WhatsApp com IA', desc: 'Lance transações por voz ou texto, direto da conversa.', tag: { label: 'Em breve · Pro', style: undefined } },
              { ico: <IconSparkles />, cls: 'is-info', title: 'Score de saúde financeira', desc: 'Pontuação da sua vida financeira com insights automáticos.', tag: { label: 'Em breve · Pro', style: undefined } },
            ].map((f, i) => (
              <article key={i} className="lp-feature lp-reveal">
                <div className={`lp-feature__ico${f.cls ? ' ' + f.cls : ''}`}>{f.ico}</div>
                <h3 className="lp-feature__title">{f.title}</h3>
                <p className="lp-feature__desc">{f.desc}</p>
                {f.tag && (
                  <span className="lp-feature__tag" style={f.tag.style}>{f.tag.label}</span>
                )}
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* ═══ COMO FUNCIONA ═══ */}
      <section className="lp-how lp-section" id="how">
        <div className="lp-container">
          <div className="lp-section__head lp-reveal">
            <p className="lp-eyebrow">Como funciona</p>
            <h2 className="lp-h2">Três passos pra começar.</h2>
            <p className="lp-lead">Sem onboarding interminável, sem 47 telas de configuração.</p>
          </div>
          <div className="lp-how__grid">
            {[
              { n: '1', title: 'Cadastre-se grátis', desc: 'Só precisa do seu email. Nenhum cartão de crédito, nenhuma trial enganosa.' },
              { n: '2', title: 'Registre suas finanças', desc: 'Adicione transações, cartões e categorias em minutos. Você importa do seu jeito.' },
              { n: '3', title: 'Assine o Pro quando fizer sentido', desc: 'Desbloqueie cartões ilimitados, IA e modo casal quando estiver pronto. No seu tempo.' },
            ].map((s, i) => (
              <article key={i} className="lp-step lp-reveal">
                <div className="lp-step__num">{s.n}</div>
                <h3 className="lp-step__title">{s.title}</h3>
                <p className="lp-step__desc">{s.desc}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* ═══ PLANOS ═══ */}
      <section className="lp-plans lp-section" id="planos">
        <div className="lp-container">
          <div className="lp-section__head lp-reveal">
            <p className="lp-eyebrow">Planos</p>
            <h2 className="lp-h2">Comece grátis. Pague apenas quando o BagCash te entrega valor.</h2>
            <p className="lp-lead">Sem fidelidade, sem multa, cancele quando quiser.</p>
          </div>

          <div className="lp-plans__toggle-wrap lp-reveal">
            <div className="lp-plans__toggle">
              <button className={period === 'month' ? 'is-active' : ''} onClick={() => setPeriod('month')}>Mensal</button>
              <button className={period === 'year' ? 'is-active' : ''} onClick={() => setPeriod('year')}>
                Anual <span className="lp-plans__toggle-save">−25%</span>
              </button>
            </div>
          </div>

          <div className="lp-plans__grid">
            {/* FREE */}
            <article className="lp-plan lp-reveal">
              <h3 className="lp-plan__name">Free</h3>
              <div>
                <div className="lp-plan__price">Grátis<small> · para sempre</small></div>
                <div className="lp-plan__price-sub">Pra começar a entender seu dinheiro hoje.</div>
              </div>
              <ul className="lp-plan__list">
                <li><IconCheck />Transações <strong>ilimitadas</strong></li>
                <li><IconCheck /><strong>1 cartão</strong> de crédito</li>
                <li><IconCheck />Histórico de <strong>3 meses</strong></li>
                <li><IconCheck /><strong>20 msgs/mês</strong> no bot WhatsApp</li>
                <li className="is-off"><IconX />Sem score de saúde financeira</li>
                <li className="is-off"><IconX />Sem export CSV/Excel</li>
                <li className="is-off"><IconX />Sem dashboard de casal</li>
              </ul>
              <button className="lp-btn lp-btn--outline lp-btn--lg lp-btn--block lp-plan__cta" onClick={onSignIn}>
                Começar grátis
              </button>
            </article>

            {/* PRO INDIVIDUAL */}
            <article className="lp-plan lp-plan--featured lp-reveal">
              <span className="lp-plan__badge">Mais popular</span>
              <h3 className="lp-plan__name">Pro Individual</h3>
              <div>
                <div className="lp-plan__price">
                  <span>{prices.individual[period]}</span>
                  <small>/mês</small>
                </div>
                <div className="lp-plan__price-sub">{priceSub.individual[period]}</div>
              </div>
              <ul className="lp-plan__list">
                <li><IconCheck />Transações <strong>ilimitadas</strong></li>
                <li><IconCheck /><strong>Cartões ilimitados</strong></li>
                <li><IconCheck />Histórico <strong>completo</strong></li>
                <li><IconCheck />Bot WhatsApp <strong>ilimitado</strong></li>
                <li><IconCheck /><strong>Score</strong> de saúde financeira</li>
                <li><IconCheck />Insights automáticos por <strong>IA</strong></li>
                <li><IconCheck />Export <strong>CSV / Excel</strong></li>
              </ul>
              <button className="lp-btn lp-btn--primary lp-btn--lg lp-btn--block lp-plan__cta" onClick={onSignIn}>
                Assinar Pro
              </button>
            </article>

            {/* PRO CASAL */}
            <article className="lp-plan lp-reveal">
              <h3 className="lp-plan__name">Pro Casal</h3>
              <div>
                <div className="lp-plan__price">
                  <span>{prices.casal[period]}</span>
                  <small>/mês</small>
                </div>
                <div className="lp-plan__price-sub">{priceSub.casal[period]}</div>
              </div>
              <ul className="lp-plan__list">
                <li><IconCheck /><strong>Tudo do Pro Individual</strong>, para os dois</li>
                <li><IconCheck />Household sharing <strong>(2 usuários)</strong></li>
                <li><IconCheck /><strong>Dashboard conjunto</strong> do casal</li>
                <li><IconCheck />Relatório mensal em <strong>PDF</strong></li>
                <li><IconCheck />Categorias e metas compartilhadas</li>
                <li><IconCheck />Despesas privadas (opcional)</li>
              </ul>
              <button className="lp-btn lp-btn--ink lp-btn--lg lp-btn--block lp-plan__cta" onClick={onSignIn}>
                Assinar Pro Casal
              </button>
            </article>
          </div>

          <p className="lp-plans__note lp-reveal">
            Pagamento via PIX, cartão de crédito ou carteira Mercado Pago. Cancele quando quiser, sem multa.
          </p>
        </div>
      </section>

      {/* ═══ TESTIMONIALS ═══ */}
      <section className="lp-section" style={{ background: 'var(--sand-1)' }}>
        <div className="lp-container">
          <div className="lp-section__head lp-reveal">
            <p className="lp-eyebrow">Quem usa, recomenda</p>
            <h2 className="lp-h2">Não é só uma planilha bonita.</h2>
          </div>
          <div className="lp-testi__grid">
            {[
              {
                quote: 'A gente brigava todo fim de mês por causa de dinheiro. Agora cada um abre o app, vê o painel e a conversa flui. Foi a melhor coisa que aconteceu pro nosso casamento.',
                initials: 'CM', color: '#2F8F5C', name: 'Camila & Marcos', city: 'São Paulo · SP',
              },
              {
                quote: 'Descobri que gastava R$ 814 por mês em delivery. Por mês. Hoje cozinho mais e o dinheiro sobra pra coisa que importa.',
                initials: 'RS', color: '#E25C4A', name: 'Rafael Souza', city: 'Belo Horizonte · MG',
              },
              {
                quote: 'Saí de 6 dívidas pra zero em 11 meses. O score ia subindo e isso me motivava a continuar. Hoje tenho reserva de emergência pela primeira vez na vida.',
                initials: 'YA', color: '#E8A33D', name: 'Yasmin Alves', city: 'Recife · PE',
              },
            ].map((t, i) => (
              <article key={i} className="lp-testi lp-reveal">
                <div className="lp-testi__stars" aria-label="5 de 5 estrelas">
                  {Array.from({ length: 5 }).map((_, j) => <IconStar key={j} />)}
                </div>
                <p className="lp-testi__quote">{t.quote}</p>
                <div className="lp-testi__author">
                  <div className="lp-testi__avatar" style={{ background: t.color }}>{t.initials}</div>
                  <div>
                    <div className="lp-testi__name">{t.name}</div>
                    <div className="lp-testi__city">{t.city}</div>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* ═══ FAQ ═══ */}
      <section className="lp-faq lp-section" id="faq">
        <div className="lp-container">
          <div className="lp-section__head lp-reveal">
            <p className="lp-eyebrow">FAQ</p>
            <h2 className="lp-h2">Perguntas que você ia fazer mesmo.</h2>
          </div>
          <div className="lp-faq__list">
            {faqs.map((faq, i) => (
              <div key={i} className={`lp-faq__item${openFaq === i ? ' is-open' : ''}`}>
                <button className="lp-faq__summary" onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                  {faq.q}
                  <span className="lp-faq__chevron" />
                </button>
                {openFaq === i && (
                  <p className="lp-faq__body">{faq.a}</p>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ═══ FINAL CTA ═══ */}
      <section className="lp-finalcta lp-section">
        <div className="lp-container">
          <div className="lp-reveal">
            <h2 className="lp-h2">Comece a controlar seu dinheiro hoje — de graça.</h2>
            <p className="lp-finalcta__sub">Sem burocracia. Sem cartão. Sem desculpa.</p>
            <button className="lp-btn lp-btn--primary lp-btn--lg" onClick={onSignIn}>
              Criar conta grátis
              <IconArrowRight />
            </button>
            <br />
            <button className="lp-finalcta__anchor" onClick={() => scrollTo('planos')}>
              Ou assine o Pro e tenha tudo desde o primeiro dia →
            </button>
          </div>
        </div>
      </section>

      {/* ═══ FOOTER ═══ */}
      <footer className="lp-footer">
        <div className="lp-container">
          <div className="lp-footer__grid">
            <div className="lp-footer__brand">
              <button className="lp-brand" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
                <img src="/logo-mark.svg" alt="BagCash" />
                BagCash
              </button>
              <p>Controle financeiro pessoal para quem não quer mais planilha. Feito no Brasil, em português.</p>
            </div>
            <div className="lp-footer__col">
              <h4>Produto</h4>
              <ul>
                <li><a href="#features" onClick={e => { e.preventDefault(); scrollTo('features') }}>Recursos</a></li>
                <li><a href="#planos" onClick={e => { e.preventDefault(); scrollTo('planos') }}>Planos</a></li>
                <li><a href="#how" onClick={e => { e.preventDefault(); scrollTo('how') }}>Como funciona</a></li>
                <li><a href="#faq" onClick={e => { e.preventDefault(); scrollTo('faq') }}>FAQ</a></li>
              </ul>
            </div>
            <div className="lp-footer__col">
              <h4>Empresa</h4>
              <ul>
                <li><a href="#">Sobre</a></li>
                <li><a href="#">Blog</a></li>
                <li><a href="mailto:contato@bagcash.com.br">Contato</a></li>
              </ul>
            </div>
            <div className="lp-footer__col">
              <h4>Legal</h4>
              <ul>
                <li><a href="/termos">Termos de uso</a></li>
                <li><a href="/privacidade">Política de privacidade</a></li>
                <li><a href="/privacidade">LGPD</a></li>
              </ul>
            </div>
          </div>
          <div className="lp-footer__bottom">
            <div className="lp-footer__copy">© 2026 BagCash · Todos os direitos reservados.</div>
            <div className="lp-footer__legal">
              <a href="/termos">Termos</a>
              <a href="/privacidade">Privacidade</a>
              <a href="mailto:contato@bagcash.com.br">contato@bagcash.com.br</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}
